"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var MyPointDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyPointDetail, _super);
    function MyPointDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分详情接口';
        _this.code = '101033';
        _this.desc = '积分详情接口';
        _this.requestParams = new point_1.MyPointDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyPointDetail;
}(service_1.BaseService));
exports.MyPointDetail = MyPointDetail;
//# sourceMappingURL=myPointDetail.js.map